import React from 'react'
import styles from './styles.module.css'
import SimpleBlockContent from '../../../SimpleBlockContent'
import CtaV2 from '../../../CtaV2'
import Spacer from '../../../Spacer'
import Text from '../../../Text'

function Page404({ title, titleTextOverride, ctasV2, text }) {
  return (
    <div className={styles.wrapper}>
      <div className={styles.contentWrapper}>
        { titleTextOverride ? titleTextOverride : <SimpleBlockContent blocks={title} noSpace/> }
        <Spacer size={32}/>
        { ctasV2 && ctasV2.map((ctaV2, i) => (
          <>
            <CtaV2 {...ctaV2}
                   sx={{
                     height: '80px',
                     width: '100%',
                     titleTextType: 'large'
                   }}
                   key={`route-${i}`}
            />
            {i < ctasV2.length - 1 && (
              <div className={styles.ctaSeparator}>
                <div className={styles.separatorLine}/>
                <Text type="large">or</Text>
                <div className={styles.separatorLine}/>
              </div>
            )}
          </>
        ))}
        <Spacer size={16}/>
        <div className={styles.ctaText}><SimpleBlockContent blocks={text} noSpace/></div>
      </div>
    </div>
  )
}

export default Page404
